// extracted by mini-css-extract-plugin
export default {"department_list":"styles_department_list__eN7oW","department_list_item":"styles_department_list_item__99v0M"};